import { render } from "./NotFound.vue?vue&type=template&id=46a88b29"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import "./NotFound.vue?vue&type=style&index=0&lang=css"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "46a88b29"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46a88b29', script)) {
    api.reload('46a88b29', script)
  }
  
  module.hot.accept("./NotFound.vue?vue&type=template&id=46a88b29", () => {
    api.rerender('46a88b29', render)
  })

}

script.__file = "src/views/NotFound.vue"

export default script